import { SWRConfig } from 'swr'

import { fetcher } from '@/data/fetcher'

// export interface SWRConfigProviderProps extends React.PropsWithChildren<{}> {}

export const SWRConfigProvider = ({ children }: React.PropsWithChildren) => {
  return (
    <SWRConfig
      value={{
        fetcher,
      }}
    >
      {children}
    </SWRConfig>
  )
}
